import { render, staticRenderFns } from "./AddQuestionAndAnswer.vue?vue&type=template&id=20d53a0e&scoped=true&"
import script from "./AddQuestionAndAnswer.vue?vue&type=script&lang=js&"
export * from "./AddQuestionAndAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d53a0e",
  null
  
)

export default component.exports